import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/build/repo/src/components/default-layout-narrow.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Join Us`}</h1>
    {/* this is a comment
     ## Community Manager
     Tattle is an open source project that aims to make accurate information more accessible to mobile first, chat app users in India. Tattle is looking for a community manager to support and grow a community around open source approaches to tackling misinformation.
     [Apply Here](https://docs.google.com/forms/d/e/1FAIpQLSf9kH9vWZoscBzxMITtxbTlmUJlogj9HejsZXUjs_H1dzssuQ/viewform?usp=sf_link)
     ## Tinkerer/Technical Specialist
     Tattle is building an archive of content circulated on chat apps. This requires us to collect messages from different chat platforms through a variety of methods such as scraping, customized bots and a mobile phone app. This requires creative tinkering with both hardware (such as Android phones) and software; and a keen curiosity about social media and chat apps. Tattle is looking for a technical specialist to support its data collection.
     [Apply Here](https://docs.google.com/forms/d/e/1FAIpQLSf9kH9vWZoscBzxMITtxbTlmUJlogj9HejsZXUjs_H1dzssuQ/viewform?usp=sf_link)
     ## Data Scientist
     We are building tools to help scale existing efforts of fact checkers and journalists to make accurate information more accessible to mobile first social media users in India. If you’re excited about multimedia content, temporal trends and social media this is your dream job. If you want to use your machine learning chops for a better information ecosystem, we want to hear from you.
     [Apply Here](https://docs.google.com/forms/d/e/1FAIpQLSf9kH9vWZoscBzxMITtxbTlmUJlogj9HejsZXUjs_H1dzssuQ/viewform?usp=sf_link)
     ## [Communications Specialist](/career/communications-specialist)
     ## [Research Associate](/career/research-associate)
     ## [Uli: Program Manager](/career/uli-program-manager)
     ## [Uli: Qualitative Researcher](/career/uli-research-1)
     ## [Uli: Consultant, Data Governance](/career/uli-research-2)
     */}
    <h2><a parentName="h2" {...{
        "href": "/career/sde1"
      }}>{`Software Engineer`}</a></h2>
    <h2><a parentName="h2" {...{
        "href": "/career/qualitative-researcher"
      }}>{`Qualitative Researcher`}</a></h2>
    <h2><a parentName="h2" {...{
        "href": "/career/digitalmarketing-consultant"
      }}>{`Digital Marketing Consultant`}</a></h2>
    <h2><a parentName="h2" {...{
        "href": "/career/backend-engineer"
      }}>{`Backend and DevOps Engineer`}</a></h2>
    <h2><a parentName="h2" {...{
        "href": "/career/senior-fullstack-developer"
      }}>{`Senior Software Engineer`}</a></h2>
    <h2>{`Open Application`}</h2>
    <p>{`If your work aligns with our mission, we are always eager to collaborate on projects. We are constantly seeking researchers, software developers, data scientists, designers, AI engineers, ethnographers, journalists, fact checkers and content creators to share our work with and find ways to work collaboratively. Please reach out to us at `}<a parentName="p" {...{
        "href": "mailto:admin@tattle.co.in"
      }}>{`admin@tattle.co.in`}</a>{` to tell us about your work. You can also `}<a parentName="p" {...{
        "href": "https://docs.google.com/forms/d/e/1FAIpQLSf9kH9vWZoscBzxMITtxbTlmUJlogj9HejsZXUjs_H1dzssuQ/viewform?usp=sf_link"
      }}>{`Apply Here`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      